// Donate-flow API helpers.
//
// startCheckout() POSTs the SKU to the API, gets back a hosted Stripe
// Checkout URL, and returns it. The caller does the redirect — both so
// the popup-blocker doesn't fire and so the call site can show a
// loading state on the button until navigation actually starts.

import { api, ApiError } from './api';

export type DonateSku =
  | 'one_time'
  | 'monthly_5'
  | 'monthly_10'
  | 'monthly_20'
  | 'monthly_50'
  | 'lifetime';

export async function startCheckout(sku: DonateSku): Promise<string> {
  const res = await api<{ url: string }>('/api/donate/checkout', {
    method: 'POST',
    body: JSON.stringify({ sku }),
  });
  return res.url;
}

export { ApiError };
